var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.559,
    height: 26.803,
    viewBox: "0 0 33.559 26.803",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "back",
    d: "M5.163,14.694,3.874,15.982,2.586,14.694l1.289-1.289Zm30.981,14.58a1.822,1.822,0,0,1-3.645,0ZM12.987,25.095,3.874,15.982l2.577-2.577,9.112,9.112ZM3.874,13.405l9.112-9.112L15.564,6.87,6.452,15.982Zm1.289-.534H23.387v3.645H5.163ZM36.145,25.628v3.645H32.5V25.628ZM23.387,12.871A12.757,12.757,0,0,1,36.145,25.628H32.5a9.112,9.112,0,0,0-9.112-9.112Z",
    transform: "translate(-2.586 -4.293)",
    fill: "#a6192e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.5ea2f0c05e278fa98a4bca05f04da1fb.svg";
export { ForwardRef as ReactComponent };